import type { InjectionKey } from 'vue'
import type { RadioGroupContext } from './types'

export const radioGroupKey: InjectionKey<RadioGroupContext> = Symbol('radioGroupKey')
